import { render, staticRenderFns } from "./EsgDisclosureDetail.vue?vue&type=template&id=6ec5b189&scoped=true"
import script from "./EsgDisclosureDetail.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureDetail.vue?vue&type=script&lang=js"
import style0 from "./EsgDisclosureDetail.vue?vue&type=style&index=0&id=6ec5b189&prod&scoped=true&lang=css"
import style1 from "./EsgDisclosureDetail.vue?vue&type=style&index=1&id=6ec5b189&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5b189",
  null
  
)

export default component.exports